import { BoxShadowLayout } from "layouts";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Button, Input } from "ui";

import {
  useFinancialSettings,
  useUpdateFinancialSettings
} from "../../../../apis";

import styles from "./LowMarginThresholdControl.module.scss";

const LowMarginThresholdControl = () => {
  const { t } = useTranslation();
  const { data } = useFinancialSettings();
  const { mutate, isLoading } = useUpdateFinancialSettings();
  const [value, setValue] = useState("");

  useEffect(() => {
    if (data) setValue(String(data.lowMarginThresholdPercent));
  }, [data]);

  const isDirty =
    data !== undefined && Number(value) !== data.lowMarginThresholdPercent;

  const handleSave = () => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed < 0 || parsed > 100) return;

    mutate(
      { lowMarginThresholdPercent: parsed },
      {
        onSuccess: () => toast.success(t("Settings were updated successfully!"))
      }
    );
  };

  return (
    <BoxShadowLayout className={styles.control}>
      <Input
        label="Low margin threshold"
        type="number"
        min={0}
        max={100}
        value={value}
        onChange={(event) => setValue(event.target.value)}
        action={<span className={styles.control__suffix}>%</span>}
        containerClassName={styles.control__field}
      />

      {isDirty && (
        <Button size="sm" loading={isLoading} onClick={handleSave}>
          {t("Save")}
        </Button>
      )}
    </BoxShadowLayout>
  );
};

export default LowMarginThresholdControl;
